module.exports = "img/edit.1db23b7.png";